import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@americanexpress/dls-react';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import { useDateSelector } from '../../context/dateContext';
import {
  getCalendarDataForSpecificDate,
  getIsMinStayVisible,
  getStartDate,
  getIsTooltipToBeShown,
} from '../../selectors/dateSelectors';
import styles from './CalendarDay.scss';

const CalendarDayMinNightsTooltip = ({
  children,
  year,
  month,
  day,
  isTooltipOpen,
  setIsTooltipOpen,
  stringDateFormat,
}) => {
  const isMobile = useMediaBreakpoint('sm-down');

  const {
    isAvailable, isSelected, minNights, isEnabled,
  } = useDateSelector(
    getCalendarDataForSpecificDate,
    stringDateFormat
  );

  const isMinStayVisible = useDateSelector(getIsMinStayVisible);
  const startDate = useDateSelector(getStartDate);
  const isTooltipToBeShown = useDateSelector(
    getIsTooltipToBeShown,
    stringDateFormat
  );
  const tooltipId = `vrDatepickerTooltip_${month}-${day}-${year}`;

  const toggleTooltip = (value) => {
    setIsTooltipOpen(value);
  };

  const tooltipHover = (value) => {
    if (!isAvailable && !isSelected && startDate) {
      return;
    }
    setIsTooltipOpen(value);
  };

  if (isMinStayVisible && isTooltipToBeShown && startDate) {
    return (
      <div className={styles.tooltip}>
        <Tooltip
          id={tooltipId}
          aria-labelledby={tooltipId}
          placement="top"
          isOpen={isTooltipOpen}
        >
          <TooltipTrigger>
            <Button
              tabIndex={-1}
              id={`toolTipBtn-${year}-${month}-${day}`}
              variant="tertiary"
              onMouseOver={() => tooltipHover(true)}
              onMouseOut={() => toggleTooltip(false)}
              onFocus={() => tooltipHover(true)}
              onBlur={() => toggleTooltip(false)}
              aria-disabled={!isSelected && (!isEnabled && !isAvailable)}
              className={clsx(
                styles.calendarDay,
                styles.toolTipButton,
                'pad-0 margin-0',
                {
                  [`${styles.tooltip} vr-tooltip-${year}-${month}-${day}`]:
              isTooltipToBeShown && isMobile,
                })}
            >
              {children}
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <span className="body-1">
              <FormattedMessage id="toolTip_minimumStay" values={{ minNights }} />
            </span>
          </TooltipContent>
        </Tooltip>
      </div>
    );
  }
  return children;
};

CalendarDayMinNightsTooltip.propTypes = {
  children: PropTypes.shape({}),
  year: PropTypes.number,
  month: PropTypes.number,
  day: PropTypes.number,
  isTooltipOpen: PropTypes.bool,
  setIsTooltipOpen: PropTypes.func,
  stringDateFormat: PropTypes.string,
};

export default CalendarDayMinNightsTooltip;
